import React from "react"
import Table from "react-bootstrap/Table"
import Map from "./Map"
import {compareFileNames} from "../utils/Utils"

function MapList({ mapList }) {
    mapList = mapList.sort((a, b) => {
        return compareFileNames(a.name, b.name);
    });
    return (
        <div className="content">
            <Table striped bordered hover size="sm">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Download link</th>
                        <th>File size</th>
                        <th>Map type</th>
                        <th>Last modified</th>
                    </tr>
                </thead>
                <tbody>
                    {mapList.map(map => <Map map={map} key={map.name} />)}
                </tbody>
            </Table>
        </div>);

}

export default MapList;